import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './contexts/ThemeContext';

// Layouts
import MainLayout from './layouts/MainLayout';

// Pages
import HomePage from './pages/HomePage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import PressReleasePage from './pages/PressReleasePage';
import FaqsPage from './pages/FaqsPage';
import NotFoundPage from './pages/NotFoundPage';
import ClientLoginPage from './pages/ClientLoginPage';
import ApplyNowPage from './pages/ApplyNowPage';
import ServicesPage from './pages/ServicesPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

// Industry Pages
import IndustriesPage from './pages/IndustriesPage';
import BuildingConstructionPage from './pages/industries/BuildingConstructionPage';
import FinancialServicesPage from './pages/industries/FinancialServicesPage';
import CorporateAdvisoryPage from './pages/industries/CorporateAdvisoryPage';
import InternationalMarketsPage from './pages/industries/InternationalMarketsPage';

// Fund Pages
import BlockchainFundPage from './pages/fund/BlockchainFundPage';
import EnergiesFundPage from './pages/fund/EnergiesFundPage';
import SharesTradingPage from './pages/fund/SharesTradingPage';
import AgriculturalFundPage from './pages/fund/AgriculturalFundPage';
import NFPPage from './pages/fund/NFPPage';
import RenewableEnergyPage from './pages/fund/RenewableEnergyPage';

// Service Pages
import InvestmentManagementPage from './pages/services/InvestmentManagementPage';
import FinancialServicePage from './pages/services/FinancialServicePage';
import PortfolioManagementServicePage from './pages/services/PortfolioManagementServicePage';
import FinancialAdvisingPage from './pages/services/FinancialAdvisingPage';
import WealthManagementPage from './pages/services/WealthManagementPage';
import FinancialPlanningPage from './pages/services/FinancialPlanningPage';
import RetirementPlanningPage from './pages/services/RetirementPlanningPage';
import ManagedPortfoliosPage from './pages/services/ManagedPortfoliosPage';
import WealthEstatePlanningPage from './pages/services/WealthEstatePlanningPage';
import MutualFundsPage from './pages/services/MutualFundsPage';
import PersonalRetirementAccountPage from './pages/services/PersonalRetirementAccountPage';
import SecuritiesTradingBrokeragePage from './pages/services/SecuritiesTradingBrokeragePage';
import TrusteeRegistrarServicesPage from './pages/services/TrusteeRegistrarServicesPage';

// Portfolio Pages
import LiquidTokenPage from './pages/portfolio/LiquidTokenPage';
import BitcoinTradingPage from './pages/portfolio/BitcoinTradingPage';
import EarlyStageTokenPage from './pages/portfolio/EarlyStageTokenPage';
import StakingFundPage from './pages/portfolio/StakingFundPage';
import LiveChatWidget from './components/LiveChatWidget';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<HomePage />} />
              <Route path="about" element={<AboutUsPage />} />
              <Route path="contact" element={<ContactUsPage />} />
              <Route path="contact-us" element={<ApplyNowPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="industries" element={<IndustriesPage />} />
              <Route path="press-release" element={<PressReleasePage />} />
              <Route path="faqs" element={<FaqsPage />} />
              <Route path="client-login" element={<ClientLoginPage />} />
              <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="terms-of-service" element={<TermsOfServicePage />} />
              
              {/* Industry routes */}
              <Route path="industries/building-construction" element={<BuildingConstructionPage />} />
              <Route path="industries/financial-services" element={<FinancialServicesPage />} />
              <Route path="industries/corporate-advisory" element={<CorporateAdvisoryPage />} />
              <Route path="industries/international-markets" element={<InternationalMarketsPage />} />
              
              {/* Fund routes */}
              <Route path="fund/blockchain" element={<BlockchainFundPage />} />
              <Route path="fund/energies" element={<EnergiesFundPage />} />
              <Route path="fund/shares-trading" element={<SharesTradingPage />} />
              <Route path="fund/agricultural" element={<AgriculturalFundPage />} />
              <Route path="fund/nfp" element={<NFPPage />} />
              <Route path="fund/renewable-energy" element={<RenewableEnergyPage />} />
              
              {/* Service routes */}
              <Route path="services/investment-management" element={<InvestmentManagementPage />} />
              <Route path="services/financial-service" element={<FinancialServicePage />} />
              <Route path="services/portfolio-management" element={<PortfolioManagementServicePage />} />
              <Route path="services/financial-advising" element={<FinancialAdvisingPage />} />
              <Route path="services/wealth-management" element={<WealthManagementPage />} />
              <Route path="services/financial-planning" element={<FinancialPlanningPage />} />
              <Route path="services/retirement-planning" element={<RetirementPlanningPage />} />
              <Route path="services/managed-portfolios" element={<ManagedPortfoliosPage />} />
              <Route path="services/wealth-estate-planning" element={<WealthEstatePlanningPage />} />
              <Route path="services/mutual-funds" element={<MutualFundsPage />} />
              <Route path="services/personal-retirement-account" element={<PersonalRetirementAccountPage />} />
              <Route path="services/securities-trading-brokerage" element={<SecuritiesTradingBrokeragePage />} />
              <Route path="services/trustee-registrar-services" element={<TrusteeRegistrarServicesPage />} />
              
              {/* Portfolio routes */}
              <Route path="portfolio/liquid-token" element={<LiquidTokenPage />} />
              <Route path="portfolio/bitcoin-trading" element={<BitcoinTradingPage />} />
              <Route path="portfolio/early-stage-token" element={<EarlyStageTokenPage />} />
              <Route path="portfolio/staking-fund" element={<StakingFundPage />} />
              
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            
            {/* Apply Now - Full page without main layout */}
            <Route path="/apply-now" element={<ApplyNowPage />} />
          </Routes>
          <LiveChatWidget />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
